/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

import { Link } from 'src/router/components';
import { CenteredColumn } from 'src/styles';

export const EmptyResults = styled(CenteredColumn)({
  marginTop: token('space.400'),
});

export const EmptyResultsInfo = styled.div({
  marginTop: token('space.100'),
  textAlign: 'center',
});

export const EmptyResultsButton = styled.div({
  marginTop: token('space.100'),
});

export const EmptyResultsLink = styled(Link)({
  '&:hover, &:focus': {
    textDecoration: 'none',
  },
});

export const NoWrapContainer = styled.span({
  whiteSpace: 'nowrap',
});
